export const EBU_BASE_HREF = '/alpha';
export const INSIGHTS_PAGE_URL = `${EBU_BASE_HREF}/insights/report/view`;
